import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useParams } from 'react-router-dom'
import {
  FeatherLoader,
  useUserService,
  useErrorService,
} from '@abroad/components'
import AddGrowthPlanModal from './AddGrowthPlanModal'
import GrowthPlanSOWTable from './GrowthPlanSOWTable'
import API from '../../utils/API'

const ClientGrowthPlan = ({ coaches }) => {
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [growthPlanDetails, setGrowthPlanDetails] = useState({
    isGrowthPlanExists: false,
    isGrowthSessionDone: false,
  })
  const [isAnyAssessmentDone, setIsAnyAssessmentDone] = useState({
    isSurveyTaken: false,
    isWisdomTaken: false,
    isProsperityTaken: false,
  })
  const { clientId } = useParams()
  const { user } = useUserService()
  const Error = useErrorService()
  const showAddSessionLink =
    isAnyAssessmentDone?.isSurveyTaken ||
    isAnyAssessmentDone?.isWisdomTaken ||
    isAnyAssessmentDone?.isProsperityTaken

  useEffect(() => {
    const getGrowthPlanDetails = async () => {
      setIsLoading(true)
      try {
        const { data } = await API.AdminAPI.coachClient.getClientSpecificData(
          clientId,
          {
            fields: ['surveyTaken', 'wisdomTaken', 'prosperityTaken'],
          },
        )
        if (data) {
          setGrowthPlanDetails({
            isGrowthPlanExists: data?.isGrowthPlanExists,
            isGrowthSessionDone: data?.isGrowthSessionDone,
          })
          setIsAnyAssessmentDone({
            isSurveyTaken: data?.surveyTaken,
            isWisdomTaken: data?.wisdomTaken,
            isProsperityTaken: data?.prosperityTaken,
          })
        }
        setIsLoading(false)
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    getGrowthPlanDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId])

  return (
    <section>
      <div
        className={classNames('d-flex title', {
          'mt-2-5': !user?.isAdmin,
          'mt-4': user?.isAdmin,
        })}>
        <h3 className='s3 mb-0'>Growth Sessions</h3>
        {isLoading ? (
          <div className='add-gp-btn align-self-center'>
            <FeatherLoader />
          </div>
        ) : (
          <>
            {/* {coaches?.length === 0 ? overlayButton() : renderAddGPButton()} */}
            {!user?.isAdmin && !growthPlanDetails.isGrowthPlanExists && (
              <p className='s5 add-gp-btn mb-0 align-self-center'>
                Client has not taken any growth session yet.
              </p>
            )}
            <AddGrowthPlanModal
              showModal={showModal}
              setShowModal={setShowModal}
              coaches={coaches}
              setGrowthPlanDetails={setGrowthPlanDetails}
            />
          </>
        )}
      </div>
      <GrowthPlanSOWTable
        growthPlanDetails={growthPlanDetails}
        showAddSessionLink={showAddSessionLink}
      />
      {/* )} */}
    </section>
  )
}

export default ClientGrowthPlan
